import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador } from '../usuario/usuario-perfil';


/** Acessos permitidos ao cadastro de motivos de perdas de vendas */
export const acessosMotivoPerdaVenda: UsuarioPerfil[] = [usuarioPerfilAdministrador];

@Injectable()
export class CanActivateMotivoPerdaVenda implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosMotivoPerdaVenda);
    }
}
